import { render } from "./AppSkeletonContact.vue?vue&type=template&id=d5fc04c4&scoped=true&ts=true"
import script from "./AppSkeletonContact.vue?vue&type=script&lang=ts"
export * from "./AppSkeletonContact.vue?vue&type=script&lang=ts"

import "./AppSkeletonContact.vue?vue&type=style&index=0&id=d5fc04c4&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5fc04c4"]])

export default __exports__